import { useQuery } from '@tanstack/react-query';
import { api, TextCapability } from '../api';
import { queryKeys } from '../query-keys';

export interface UseTextCapabilitiesResult {
  /** The platform text-capability catalog (text-fast / text-standard / text-advanced). */
  capabilities: TextCapability[];
  loading: boolean;
  error: Error | null;
}

/**
 * Fetches the plugin AI text-capability catalog (GET /v1/models/text-capabilities).
 *
 * Powers the plugin builder's capability picker. A plugin author selects a
 * capability id (sunset-proof); the platform resolves it to the current model
 * at invoke time and re-points it when a model is retired.
 */
export function useTextCapabilities(): UseTextCapabilitiesResult {
  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.models.textCapabilities(),
    queryFn: () => api.listTextCapabilities(),
    staleTime: 10 * 60 * 1000, // The catalog changes rarely.
  });

  return {
    capabilities: data?.capabilities ?? [],
    loading: isLoading,
    error: error instanceof Error ? error : error ? new Error(String(error)) : null,
  };
}
